// @flow

import urlPattern from './urlPattern';
import TextBlock from './TextBlock';
import UrlBlock from './UrlBlock';
import MixedBlock from './MixedBlock';
import SpacingBlock from './SpacingBlock';

type EachBlock = Generator<TextBlock | UrlBlock | MixedBlock | SpacingBlock, void, void>;

/**
 * Iterates over each constituent block of the given `messageText` payload.
 */
export default function* eachBlock(messageText: string): EachBlock {
  let spacingBlockLines = 0;
  function* emitSpacerBlockIfNecessary() {
    if (spacingBlockLines > 0) {
      yield new SpacingBlock(spacingBlockLines);
      spacingBlockLines = 0;
    }
  }
  for (const line of messageText.trim().split(/\n/)) {
    const trimmedLine = line.trim();
    const trimmedLineLength = trimmedLine.length;
    if (trimmedLineLength === 0) {
      spacingBlockLines++;
    } else {
      yield* emitSpacerBlockIfNecessary();
      const match = urlPattern.exec(trimmedLine);
      if (match) {
        if (match[0].length === trimmedLineLength) {
          yield new UrlBlock(trimmedLine);
        } else {
          yield new MixedBlock(trimmedLine);
        }
      } else {
        yield new TextBlock(trimmedLine);
      }
    }
  }
}
